import React, { useContext, useState } from 'react';
import track from 'react-tracking';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Waypoint } from 'react-waypoint';
import { Avatar, Icon } from '@edx/paragon';
import { Person } from '@edx/paragon/icons';

import Truncate from 'react-truncate';
import { getMarketingSiteLink } from '@utils/edxLinks';
import { submitEvent } from '@utils/analytics';
import { getWebviewUrl } from '@utils/program';
import { WebviewContext } from '@utils/context';
import { getInstructorPositionOrg, getFullName } from '@utils/formatting';

function InstructorCard(props) {
  const {
    profileImageUrl,
    position = {
      title: '',
      organizationName: '',
    },
    slug,
    givenName,
    familyName,
  } = props;
  const [onScreen, setOnScreen] = useState(false);
  const instructorUrl = getMarketingSiteLink(`/bio/${slug}`);
  const webview = useContext(WebviewContext);

  const handleClick = (event) => {
    const componentProps = {
      category: 'navigation',
      link: event.currentTarget.pathname.link,
    };
    const { tracking } = props;
    submitEvent(tracking, componentProps, 'edx.bi.link.instructor.clicked');
  };

  return (
    <a className="w-100 w-sm-auto" href={webview ? getWebviewUrl(`/bio/${slug}`) : instructorUrl} onClick={handleClick}>
      <Waypoint onEnter={() => setOnScreen(true)}>
        <div className="instructor-card px-4 py-3.5 rounded">
          <div className="text-primary-100 d-flex flex-column justify-content-start text-center">
            {onScreen
              ? (
                <Avatar
                  src={profileImageUrl}
                  onClick={handleClick}
                  size="xl"
                  className={classnames('mx-auto', 'border-0', { 'mb-3': position }, { 'mb-5': !position })}
                />
              ) : (
                <div className="default-user">
                  <Icon className="m-auto" style={{ height: '1.6rem', width: '1.6rem' }} src={Person} />
                </div>
              )}
            <h3 className="lead font-weight-bold text-primary-100 mt-2 mb-3">{getFullName({ givenName, familyName })}</h3>
            {position
              && (
                <Truncate
                  lines={3}
                  trimWhitespace
                ><p className="mt-2">{getInstructorPositionOrg(position)}</p>
                </Truncate>
              )}
          </div>
        </div>
      </Waypoint>
    </a>
  );
}

export const InstructorCardProps = {
  position: PropTypes.shape({
    title: PropTypes.string,
    organizationName: PropTypes.string,
  }),
  givenName: PropTypes.string,
  familyName: PropTypes.string,
  profileImageUrl: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  tracking: PropTypes.shape(),
};

InstructorCard.propTypes = InstructorCardProps;

InstructorCard.defaultProps = {
  position: null,
  givenName: '',
  familyName: '',
  tracking: {},
};

export default track({
  component: 'instructor-card',
})(InstructorCard);
